var _defs, _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcSecurityCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 24",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "securitycode"
  }, "Credit Card Security Code Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "securitycode"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{fill:#b1c5d7;}.cls-2{fill-rule:evenodd;}.cls-4{isolation:isolate;}.cls-5{fill:#134ee6;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -671.63,
    y: -303.06,
    width: 1280,
    height: 1040
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.5,0H2.5A2.5,2.5,0,0,0,0,2.5v19A2.5,2.5,0,0,0,2.5,24h31A2.5,2.5,0,0,0,36,21.5V2.5A2.5,2.5,0,0,0,33.5,0ZM35,21.5A1.5,1.5,0,0,1,33.5,23H2.5A1.5,1.5,0,0,1,1,21.5V10H35ZM1,6V2.5A1.5,1.5,0,0,1,2.5,1h31A1.5,1.5,0,0,1,35,2.5V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m28.38 20.76a4.7 4.7 0 1 1 4.7 -4.7 4.71 4.71 0 0 1 -4.7 4.7zm0-9a4.33 4.33 0 1 0 4.34 4.33 4.33 4.33 0 0 0 -4.34 -4.36z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    "data-name": 123
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.58,17.11h.61v-2h-.48v-.23a1.53,1.53,0,0,0,.56-.19h.26v2.38h.55v.28h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.64,17.19c.8-.8,1.25-1.28,1.25-1.71a.46.46,0,0,0-.5-.52.78.78,0,0,0-.57.32l-.2-.2a1,1,0,0,1,.81-.4.74.74,0,0,1,.8.78c0,.5-.46,1-1.09,1.66l.45,0h.77v.29H27.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.8,17.07l.18-.23a.9.9,0,0,0,.68.32.5.5,0,0,0,.55-.49c0-.32-.22-.53-.85-.53v-.26c.57,0,.76-.22.76-.5a.41.41,0,0,0-.46-.42.79.79,0,0,0-.57.27L29.9,15a1.13,1.13,0,0,1,.77-.33c.46,0,.8.24.8.67A.66.66,0,0,1,31,16v0a.68.68,0,0,1,.58.67.79.79,0,0,1-.88.76A1.17,1.17,0,0,1,29.8,17.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcSecurityCode);
export default __webpack_public_path__ + "static/media/cc-security-code.f4180ad2491f071ebdde0323c351a616.svg";
export { ForwardRef as ReactComponent };